import { Component, OnInit, Input, Output, EventEmitter, QueryList, ViewChildren, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { ListingService, ListingSearchService, QueryFilterService, UserService, LogService } from '@app/services';
import { ListingQuery, TrackedEvent } from '@app/models';
import { FormsModule } from '@angular/forms';



@Component({
    selector: 'search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class SearchBoxComponent implements OnInit {


  @Output() searchTextValueChanged = new EventEmitter<string>();

  /**
   * Event for when the search text enter/return key is pressed
   */
  @Output() searchTextKeyEnter = new EventEmitter();

  @ViewChildren("searchComboBox")
  public searchBoxInputs: QueryList<HTMLInputElement>; // there should only be 1 in the list


  private _showSearchIcon: boolean = true;
  private _placeHolderText: string;

  constructor(readonly listingSearchService: ListingSearchService,
    readonly userService: UserService,
    readonly logService: LogService,
    readonly changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {

  }

  /**
   * Method that fires with the Search Icon  is clicked
   */
  public onSearchIconClick() {
    console.log('SearchBoxComponent.onSearchIconClick');
  }

  /**
   * Method handles when the user presses the Enter/Return key
   */
  public OnSearchBoxEnter() {
    console.log('SearchBoxComponent.OnSearchBoxEnter');

    this.searchTextKeyEnter.emit();
  }

  /**
   * Empties the search box
   */
  public clear() {
    this.value = null;
    this.changeDetectorRef.detectChanges();
  }
  
  /** 
   * Gets the search box HTML Input Element   * 
   */
  public get searchBoxInput() : HTMLInputElement {
    if (this.searchBoxInputs && this.searchBoxInputs.length > 0){
      return this.searchBoxInputs.first;
    }

    return null;    
  }
  
  


  /** 
   * Boolean indicating if the search icon is shown or not
   */
  public get showSearchIcon(): boolean {
    return this._showSearchIcon;
  }

  @Input('showSearchIcon')
  public set showSearchIcon(v: boolean) {
    this._showSearchIcon = v;
  }


  /** 
   * Placeholder text property (getter) for the input box
   */
  public get placeHolderText(): string {
    console.log('placeHolderText get', this._placeHolderText);

    return this._placeHolderText;
  }

  
  
 
 private _value : string;
 public get value() : string {
   return this._value;
 }
 public set value(v : string) {
   this._value = v;
 }
 
  

  /**
   * Handles key press events for the search box input element
   */
  public OnSearchBoxKeyUp(evt:any) {
    console.log('SearchBoxComponent.OnSearchBoxKeyUp', this.searchBoxInput.value, evt);

    this.value = evt.target.value;

    this.searchTextValueChanged.emit(this.value);    
  }
  

  /**
   * Placeholder text property (setter) for the input box
   * For Example: [placeHolderText]="'Search by listing name, description, or other details.'"   * 
   */
  @Input('placeHolderText')
  public set placeHolderText(v: string) {
    console.log('placeHolderText set', v);
    this._placeHolderText = v;
  }


  public onSearchBoxSelectedChanged(value: any) {
    console.log('SearchBoxComponent.onSearchBoxSelectedChanged');

    console.log('SearchBoxComponent.onSearchBoxSelectedChanged --> emitting...');
    this.searchTextValueChanged.emit(value);
    console.log('SearchBoxComponent.onSearchBoxSelectedChanged --> emitted ',value);
 
    let query = {} as ListingQuery;
    query.searchText = value;
    query.userAccountId = this.userService.userId;
    this.logTrackedEvent(this.userService.userId, JSON.stringify(query));
  }

  /**
   * Logs data as a tracked event
   * @param userId 
   * @param json 
   */
  private logTrackedEvent(userId, json) {
    let trackedEvent: TrackedEvent = { 'userAccountId': userId,
                                       'tierName': 'Presentation',
                                       'component': 'SearchBoxComponent',
                                       'jsonData': json } as TrackedEvent;

    this.logService.addTrackedEvent(trackedEvent).subscribe(result => {
      console.log('lte success');
    });

  }

}
